export const defaultValues = {
  groupName: '',
  mediumTicket: { min: 1, max: 1000000 },
  age: { min: 18, max: 80 },
  zenetRating: { min: 1, max: 5 },
  state: '',
  gender: 'ALL',
};
